import { useState } from 'react';
import { EmailMessage } from '../../hooks/useEmailAPI';
import EmailListItem from './EmailListItem';

interface EmailListProps {
  emails: EmailMessage[];
  loading: boolean;
  onSelectEmail: (email: EmailMessage) => void;
}

const EmailList = ({ emails, loading, onSelectEmail }: EmailListProps) => {
  const [selectedEmailId, setSelectedEmailId] = useState<string | null>(null);
  
  if (loading) {
    return (
      <div className="p-4 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#ff8c42] mx-auto"></div>
        <div className="mt-2 text-[#8a7266]">Loading emails...</div>
      </div>
    );
  }
  
  if (emails.length === 0) {
    return (
      <div className="p-8 text-center text-[#8a7266]">
        <div className="text-[#ff8c42] mb-2">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto">
            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="currentColor"/>
          </svg>
        </div>
        No emails found in this folder
      </div>
    );
  }
  
  return (
    <div className="border rounded-lg overflow-hidden">
      {emails.map((email) => (
        <EmailListItem 
          key={email.id}
          email={email}
          isSelected={email.id === selectedEmailId}
          onClick={() => {
            setSelectedEmailId(email.id);
            onSelectEmail(email);
          }}
        />
      ))}
    </div>
  );
};

export default EmailList;